import { UserLayout } from "@/components/layouts/user-layout"
import { PickupCartScreen } from "@/features/user/pickup-cart-screen"

/**
 * No props. The cart is in localStorage and the server has never seen it — the
 * restaurant and whether this diner may pay arrive on the shared `pickup` prop.
 */
export default function UserPickupCart() {
  return (
    <UserLayout fillsViewport>
      <PickupCartScreen />
    </UserLayout>
  )
}
